import type {
  Sequence,
  SequenceEnrollRequest,
  SequenceEnrollment,
  SequenceInput,
  SequenceStep,
} from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export function listSequences(params?: {
  q?: string;
}): Promise<{ sequences: Sequence[] }> {
  return apiGet("/api/sequences", params);
}

export function getSequence(
  sequenceId: string,
): Promise<{ sequence: Sequence; enrollments: SequenceEnrollment[] }> {
  return apiGet(`/api/sequences/${sequenceId}`);
}

export function createSequence(
  input: SequenceInput,
): Promise<{ sequence: Sequence }> {
  return apiPost("/api/sequences", input);
}

export function updateSequence(
  sequenceId: string,
  fields: Partial<SequenceInput> & {
    active?: boolean;
    archived?: boolean;
    steps?: SequenceStep[];
  },
): Promise<{ sequence: Sequence }> {
  return apiPatch(`/api/sequences/${sequenceId}`, fields);
}

export function deleteSequence(sequenceId: string): Promise<void> {
  return apiDelete(`/api/sequences/${sequenceId}`);
}

export function enrollInSequence(
  sequenceId: string,
  body: SequenceEnrollRequest,
): Promise<{ enrollments: SequenceEnrollment[]; skipped: string[] }> {
  return apiPost(`/api/sequences/${sequenceId}/enroll`, body);
}

export function patchSequenceEnrollment(
  sequenceId: string,
  leadId: string,
  body: { status?: SequenceEnrollment["status"]; mailboxHint?: string },
): Promise<{ enrollment: SequenceEnrollment }> {
  return apiPatch(
    `/api/sequences/${sequenceId}/enrollments/${leadId}`,
    body,
  );
}

export function processDueSequences(): Promise<{
  processed: number;
  tasksCreated: number;
  finished: number;
}> {
  return apiPost("/api/sequences/process-due", {});
}
